import axios from "axios";

const Api = axios.create({
    baseURL: process.env.REACT_APP_IA_API_URL,
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_IA_API_KEY}`,
    },
});

export default Api;